import { createSlice } from "@reduxjs/toolkit";
import { UserProps } from "./types";

interface AuthState {
  isAuthenticated: boolean;
  admin: UserProps | null;
}

const initialState: AuthState = {
  isAuthenticated: false,
  admin: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    saveAdminDetails: (state, action) => {
      const { admin, isAuthenticated } = action.payload;
      return {
        ...state,
        isAuthenticated: isAuthenticated,
        admin: admin,
      };
    },
    saveLogout: (state) => {
      return {
        ...state,
        isAuthenticated: false,
        admin: null,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const { saveAdminDetails, saveLogout } = authSlice.actions;

export default authSlice.reducer;
